import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { ProductOptionKey } from '../../../../interfaces/ProductOption/ProductOptionKey';
import { sharedStyles } from '../../../../utils/Style';

interface UpsertProductOptionDialogProps {
  keys: ProductOptionKey[];
  initialValues?: string[];
  open: boolean;
  onUpsert: (values: string[]) => void;
  onClose: () => void;
}

export const UpsertProductOptionDialog = (
  props: UpsertProductOptionDialogProps,
) => {
  const [values, setValues] = useState<string[]>([]);

  useEffect(() => {
    setValues(
      props.initialValues ?? props.keys.map((key) => key.values[0].name),
    );
  }, [props.keys, props.initialValues]);

  const handleChange = (index: number, value: string) => {
    const newValues = cloneDeep(values);

    newValues[index] = value;
    setValues(newValues);
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle sx={{ ...sharedStyles.h6 }}>Yeni Varyant</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          component='div'
          sx={{ display: 'flex', flexDirection: 'column', mt: 1.5, gap: 1.5 }}
        >
          {props.keys.map((key, i) => (
            <FormControl key={i} size='small' sx={{ width: 350 }}>
              <InputLabel>{key.key}</InputLabel>
              <Select
                label={key.key}
                value={values[i] ?? ''}
                onChange={(e) => handleChange(i, e.target.value)}
              >
                {key.values.map((value, j) => (
                  <MenuItem key={j} value={value.name}>
                    {value.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          İptal
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => props.onUpsert(values)}
          sx={sharedStyles.buttonText}
        >
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
};
